import { ContactDetailsFormProps } from '@/src/components/common/forms/contactDetailsForm'
import { Customer, User } from '@/src/types/itinerary'
import { useCallback, useEffect, useMemo, useState } from 'react'

export const useContactDetails = (customer: Customer, userTravellerData : User | undefined) => {
    const defaultMobileCountryCode = '966' // saudi arabia
    const initialContactDetails: Customer = useMemo(() => {
        return {
            ...customer,
            email: customer.email || userTravellerData?.customer?.email || '',
            mobile: customer.mobile || '',
            mobileCountryCode: customer.mobileCountryCode || defaultMobileCountryCode
        }
    }, [customer, userTravellerData])

    const [contactDetails, setContactDetails] = useState<Customer>(initialContactDetails)

    const onChangeContactDetails: ContactDetailsFormProps['onChange'] = useCallback((key, value) => {
        setContactDetails(prev => ({
            ...prev,
            [key]: value
        }))
    }, [])

    useEffect(() => {
        if (userTravellerData?.customer?.email && !contactDetails.email) {
            setContactDetails(prev => ({
                ...prev,
                email: userTravellerData?.customer?.email || ''
            }))
        }
    }, [userTravellerData])

    return {
        contactDetails,
        setContactDetails,
        onChangeContactDetails
    }
}
